export default __webpack_public_path__ + "static/media/boiteAzureBg.36c12908.jpg";